import type { FaireProductEntity } from "../../entity_types/product";

export const p_nyerjahvrb: FaireProductEntity = {
  token: "p_nyerjahvrb",
  type: "product",
  name: "Sweet & Savory Ghee",
  brandToken: "b_xhgxgkda5f",
  brandName: "Jar Masala",
  imageUrl:
    "https://cdn.faire.com/fastly/1584b5cb3239d311fc2bb23c85b7234abff65466f5aeec9c9812cc7e9c67d810.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc380e0b1823ee87737f62f35bd4f4bbcbc1e1a6a3343ee39cca142a698ecf61.jpeg",
    "https://cdn.faire.com/fastly/341fd2014e3274f18f18f0acc95566bc7dd3d7ca1fab834b1116a87f6796ae08.jpeg",
    "https://cdn.faire.com/fastly/da8d5ad2826f580f280a8cd044a3312e03c369ad73ed6bc4bff7f046836cec06.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Our Sweet and Savory Ghee is a rich clarified butter infused with the sweet and spicy flavors. Perfect balance of sweetness and spice gives a deeper, caramelized, and nutty taste that enhances both sweet and savory dishes.\n\nUse it to elevate grilled seafood, meats, BBQ, roasted vegetables, rice or pasta. Sweet & Savory ghee also works wonderfully in marinades or dressings when paired with fresh herbs. With its high smoke point, our sweet and savory Ghee is perfect for high heat cooking and adds a refreshing, sweet and peppery twist to any dish.\n\nCrafted in small batches for optimal flavor and freshness, this lactose-free, shelf-stable ghee combines the richness of clarified butter with premium, aromatic spices.\n\n8oz. | $8.50\nHandcrafted by a women-owned artisanal company in Snellville, GA.\nProudly crafted in the USA using local and imported ingredients.\n\nIngredients:\nClarified Butter (Milk), Natural Cane Sugar, Onion, Garlic, Oregano, Parsley, Cumin, Coriander, Basil, Garam Masala, Black Pepper, Cayenne, Kashmiri Chili, Kosher Salt",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:24.748Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
